export default __webpack_public_path__ + "static/media/ross.919526fd.jpg";